import { createRoot } from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "./styles.css";
import { initDevErrorHandler } from "./utils/devErrorHandler";
import { accountUidFromHostname } from "./accountHost";
import { isLegalPath } from "./legalRoutes";
import { loadEntryWithRecovery } from "./bootstrap/loadEntryWithRecovery";

const isPublicAuthPath = (pathname: string) => {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized === "/admin/login"
    || normalized === "/admin/signed-out"
    || Boolean(accountUidFromHostname() && /^\/(login|signed-out)$/.test(normalized));
};


initDevErrorHandler();
const pathname = window.location.pathname;
const loadEntry = () => isLegalPath(pathname)
  ? import("./LegalEntry.tsx")
  : isPublicAuthPath(pathname)
    ? import("./LoginEntry.tsx")
    : import("./App.tsx");

void loadEntryWithRecovery(loadEntry, {
  storage: window.sessionStorage,
  reload: () => window.location.reload(),
}).then((entry) => {
  if (!entry) return;
  const Root = entry.default;
  createRoot(document.getElementById("root")!).render(<Root />);
}).catch((error: unknown) => {
  console.error("Failed to load the application entry module", error);
  const root = document.getElementById("root");
  if (!root) return;
  root.textContent = "The application could not be loaded. Refresh the page to try again.";
});
